module.exports = __webpack_public_path__ + "static/img/11.ac0309a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/sp/11.png
// module id = REc+
// module chunks = 0